import '../StoresPage/StoresPage.less';
// import './EShopPage.less';
export const prefix = 'bm-p-stores'; 
export const prefix2 = 'bm-p-EShopPage';

export { default } from './EShopPage';
